import {
  texto, gridSizeMdLg6, gridSize, TipoIdentificacionEnumChoice,
  servicioCorreoData, gridSizeMdLg1,
  emailENUM,
  gridSizeConst10,
  gridSizeConst2,
  gridSizeMdLg12,
} from "@/shared"
import {
  TabTextLabel, CustomTextFieldNoForm, CustomTextField,
  CustomAutocompleteArrString, CustomTextFieldNumberComponente,
  CustomAutocomplete,
} from "@/shared/components/ui"
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente"
import { Grid, IconButton, Typography } from "@mui/material"
import { TipoPlanCorporativo } from "@/shared/interfaces"
import { UseFormReturn } from "react-hook-form"
import { TooltipIconEdit } from "@/erp/sale"
import SearchIcon from '@mui/icons-material/Search';
import CondicionVentaPymes from "@/erp/venta_pymes/prospecto/shared/componente/condicion_venta_pymes/CondicionVentaPymes"
import { IProspectoPymes } from "@/shared/interfaces/erp/ventas_pymes/prospecto_pymes.interface"
import { IPreventaPymesForm } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface"
interface TabInformacionPersonalProps {
  dataProspecto: IProspectoPymes | null
  editSupervisor: boolean
  form: any // PERF: UseFormReturn<IPreventaPymesForm> instanciaba Path<T> caro en el tsc
  isLoadingProspecto?: boolean,
  handleBuscarRepresententeLegal: () => void
  handleBuscarPorCedulaSetNombre: (identificacion: string, key: string) => void
  prospectoRes?: IProspectoPymes[] | undefined
  handleBuscarProspecto: (value: string) => void
  handleSelectProspecto: (value: IProspectoPymes) => void
  buscarProspecto?: boolean
  valorRestriccionCel?:any
}

export default function TabInformacionPersonalPreventaPymes({
  dataProspecto,
  editSupervisor,
  form,
  prospectoRes,
  isLoadingProspecto,
  handleBuscarProspecto,
  handleSelectProspecto,
  buscarProspecto = false,
  handleBuscarRepresententeLegal,
  handleBuscarPorCedulaSetNombre,
  valorRestriccionCel
}: TabInformacionPersonalProps) {

  const {
    control,
    reset,
    formState: { errors }
  } = form

  return (
    <Grid container spacing={3} >

      {buscarProspecto && (
        <>
          <Grid item xs={12}>
            <TabTextLabel text={'Buscar Prospecto'} mt={0} pb={2} pl={0} pt={2} />
          </Grid>

          <Grid item container {...gridSizeMdLg6}
            spacing={3} alignItems={'center'}>
            <CustomTextFieldNumberComponente
              size={gridSizeConst10}
              max={13}
              type={TiposTextFieldNumberEnum.IDENTIFICACION}
              label={texto.identificacion}
              error={undefined}
              helperText={undefined}
              control={control}
              name="identificacion_prospecto"
              defaultValue={form.getValues().identificacion_prospecto ?? ''}
              onChangeValue={identificacion => {
                handleBuscarProspecto && handleBuscarProspecto(identificacion)
                //form.setValue('prospecto', '')
              }}
            />
            <Grid item {...gridSizeConst2}>
              <IconButton onClick={(e: any) => {
                e.preventDefault();
                handleBuscarProspecto && handleBuscarProspecto(form.getValues().identificacion_prospecto ?? '')

              }} size="small">
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>

          <CustomAutocomplete<IProspectoPymes>
            size={gridSizeMdLg6}
            label="Prospecto"
            name="prospecto"
            options={prospectoRes ?? []}
            valueKey="razon_social"
            actualValueKey="codigo"
            defaultValue={form.getValues().prospecto ?? ""}
            isLoadingData={isLoadingProspecto ?? false}
            control={control}
            error={errors.prospecto}
            helperText={errors.prospecto?.message}
            onChangeRawValue={(value) => {
              console.log(value);

              handleSelectProspecto && handleSelectProspecto(value)
            }}
          />


          {dataProspecto && (
            <Grid item {...gridSizeMdLg12}>
              <CondicionVentaPymes
                form={form}
                servicio={TipoPlanCorporativo.PYME}
                handleDataSolicitud={(_aux) => {

                }}

              />

            </Grid>
          )

          }

        </>
      )

      }
      <Grid item xs={12}>
        <TabTextLabel text={texto.informacion_personal} mt={0} pb={2} pl={0} pt={2} />
      </Grid>

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.tipo_documento}
        defaultValue={dataProspecto?.tipo_identificacion ?? ''}
        value={dataProspecto?.tipo_identificacion ?? ''}
        size={gridSizeMdLg6}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.identificacion}
        defaultValue={dataProspecto?.identificacion ?? ''}
        value={dataProspecto?.identificacion ?? ''}
        size={gridSizeMdLg6}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={texto.nombre}
        defaultValue={dataProspecto?.razon_social ?? ''}
        value={dataProspecto?.razon_social ?? ''}
        size={gridSize}
      />

      {dataProspecto?.tipo_identificacion == TipoIdentificacionEnumChoice.RUC && (
        <>
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.regimen}
            defaultValue={dataProspecto?.regimen ?? ''}
            value={dataProspecto?.regimen ?? ''}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_contribuyente}
            defaultValue={dataProspecto?.tipo_contribuyente ?? ''}
            value={dataProspecto?.tipo_contribuyente ?? ''}
            size={gridSizeMdLg6}
          />

        </>
      )
      }

      {
        dataProspecto?.tipo_identificacion != TipoIdentificacionEnumChoice.RUC && (
          <>
            <CustomTextFieldNoForm
              disabled={true}
              label={texto.fecha_nacimiento}
              defaultValue={dataProspecto?.fecha_nacimiento ?? ''}
              value={dataProspecto?.fecha_nacimiento ?? ''}
              size={gridSizeMdLg6}
            />



            <CustomTextFieldNoForm
              disabled={true}
              label={`Servicio`}
              defaultValue={`Servicio ${dataProspecto?.linea ?? ''}`}
              value={`Servicio ${dataProspecto?.linea ?? ''}`}
              size={gridSizeMdLg6}
            />

          </>
        )
      }




      <Grid item container xs={12} spacing={3}>
        <CustomTextFieldNoForm
          disabled={true}
          label={`Celular`}
          defaultValue={dataProspecto?.celular ?? ''}
          value={dataProspecto?.celular ?? ''}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNumberComponente
          required={false}
          size={gridSizeMdLg6}
          endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
          type={TiposTextFieldNumberEnum.TELEFONO}
          label={texto.telefono_fijo}
          error={errors.celular_2}
          helperText={errors.celular_2?.message}
          control={form.control}
          name="celular_2" //Teléfono Adicional
          defaultValue={form.getValues().celular_2 || ''}
          customRestriccionCelular={valorRestriccionCel}
          max={9}
        />
      </Grid>



      <Grid container item xs={12} spacing={3}>
        <CustomTextField
          endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
          name="email_temporal"
          type='lower'
          label={texto.email}
          control={form.control}
          defaultValue={form.getValues().email_temporal || ''}
          error={errors.email_temporal}
          helperText={errors.email_temporal?.message ?? ''}
          size={gridSizeMdLg6}
          onChangeValue={(value) => {

            if (form.getValues().servicio_correo == emailENUM.MANUALMENTE)
              return reset({ ...form.getValues(), email_temporal: value })

            reset({
              ...form.getValues(),
              email_temporal: value.replace(/[@\s]/g, '')
            })
          }}
        />

        <CustomAutocompleteArrString
          endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
          label="Servicio de correo"
          name="servicio_correo"
          options={servicioCorreoData}
          control={form.control}
          defaultValue={form.getValues().servicio_correo}
          error={errors.servicio_correo}
          helperText={errors.servicio_correo?.message?.toString() ?? ''}
          isLoadingData={false}
          size={gridSizeMdLg6}
          onChangeValue={(value) => {

            if (form.getValues().email_temporal && value == emailENUM.MANUALMENTE)
              return reset({ ...form.getValues(), servicio_correo: value, email_temporal: '' })

          }}
        />
      </Grid>



      <Grid item xs={12}>
        <Typography
          variant="subtitle2"
          style={{
            color: '#6C737F',
          }}
        >
          {texto.nota_correo_valido}
        </Typography>
      </Grid>


      <Grid item xs={12}>
        <TabTextLabel text={'REPRESENTANTE LEGAL'} mt={0} pb={2} pl={0} pt={2} />
      </Grid>

      <CustomAutocompleteArrString
        size={gridSizeMdLg6}
        label={texto.tipo_documento}
        name="representante_legal_tipo_identificacion"
        options={[TipoIdentificacionEnumChoice.CEDULA]}
        defaultValue={form.getValues().representante_legal_tipo_identificacion ?? ''}
        isLoadingData={false}
        control={control}
        error={errors.representante_legal_tipo_identificacion}
        helperText={errors.representante_legal_tipo_identificacion?.message}
      />

      <Grid item container {...gridSizeMdLg6}
        spacing={3} alignItems={'center'}>

        <CustomTextFieldNumberComponente
          size={gridSizeConst10}
          max={10}
          type={TiposTextFieldNumberEnum.IDENTIFICACION}
          label={texto.identificacion}
          error={errors.representante_legal_identificacion}
          helperText={errors.representante_legal_identificacion?.message}
          control={control}
          name="representante_legal_identificacion"
          defaultValue={''}
          onChangeValue={(e) => {
            if (e.length == 10 || e.length == 13) {
              handleBuscarRepresententeLegal();
            } else {
              form.setValue('representante_legal_razon_social', '')
            }
          }}
        />

        <Grid item {...gridSizeConst2}>
          <IconButton onClick={() => {
            handleBuscarRepresententeLegal();
          }} size="small">
            <SearchIcon />
          </IconButton>
        </Grid>

      </Grid>



      {/*  */}

      <CustomTextField
        // disabled
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        type='texto_sin_numeros'
        control={form.control}
        name="representante_legal_razon_social"
        label={'Razon Social del Representante Legal'}
        error={errors.representante_legal_razon_social}
        defaultValue={form.getValues().representante_legal_razon_social || ''}
        helperText={errors.representante_legal_razon_social?.message}
      />

      {
        editSupervisor && (
          <Grid item {...gridSizeMdLg1}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <TooltipIconEdit />
          </Grid>
        )
      }

      <CustomTextFieldNumberComponente
        required={false}
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        size={gridSizeMdLg6}
        type={TiposTextFieldNumberEnum.CELULAR}
        label={'Celular'}
        error={errors.representante_celular1}
        helperText={errors.representante_celular1?.message}
        control={form.control}
        defaultValue={form.getValues().representante_celular1 || ''}
        name="representante_celular1"
        customRestriccionCelular={valorRestriccionCel}
      />

      <CustomTextFieldNumberComponente
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        required={false}
        size={gridSizeMdLg6}
        type={TiposTextFieldNumberEnum.TELEFONO}
        label={'Teléfono Adicional'} //TELEFONO ADICIONAL REFERENCIA
        error={errors.representante_celular2}
        helperText={errors.representante_celular2?.message}
        control={form.control}
        defaultValue={form.getValues().representante_celular2}
        name="representante_celular2"
        customRestriccionCelular={valorRestriccionCel}
        max={9}
      />


      <Grid item xs={12}>
        <TabTextLabel text={'RESPONSABLE CONTABLE'} mt={0} pb={2} pl={0} pt={2} />
      </Grid>

      <CustomAutocompleteArrString
        size={gridSizeMdLg6}
        label={texto.tipo_documento}
        name="responsable_contable_tipo_identificacion"
        options={[TipoIdentificacionEnumChoice.CEDULA]}
        defaultValue={form.getValues().responsable_contable_tipo_identificacion ?? ''}
        isLoadingData={false}
        control={control}
        error={errors.responsable_contable_tipo_identificacion}
        helperText={errors.responsable_contable_tipo_identificacion?.message}
      />

      <Grid item container {...gridSizeMdLg6}
        spacing={3} alignItems={'center'}>

        <CustomTextFieldNumberComponente
          size={gridSizeConst10}
          max={10}
          type={TiposTextFieldNumberEnum.IDENTIFICACION}
          label={texto.identificacion}
          error={errors.responsable_contable_identificacion}
          helperText={errors.responsable_contable_identificacion?.message}
          control={control}
          name="responsable_contable_identificacion"
          defaultValue={''}
          onChangeValue={(e) => {
            if (e.length == 10 || e.length == 13) {
              handleBuscarPorCedulaSetNombre(e, "responsable_contable_razon_social");
            } else {
              form.setValue('responsable_contable_razon_social', '')
            }
          }}
        />

        <Grid item {...gridSizeConst2}>
          <IconButton onClick={() => {
            handleBuscarPorCedulaSetNombre(
              form.getValues().responsable_contable_identificacion ?? '',
              "responsable_contable_razon_social");
          }} size="small">
            <SearchIcon />
          </IconButton>
        </Grid>

      </Grid>



      {/*  */}

      <CustomTextField
        // disabled
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        type='texto_sin_numeros'
        control={form.control}
        name="responsable_contable_razon_social"
        label={'Razon Social del Responsable Contable'}
        error={errors.responsable_contable_razon_social}
        defaultValue={form.getValues().responsable_contable_razon_social || ''}
        helperText={errors.responsable_contable_razon_social?.message}
      />

      {
        editSupervisor && (
          <Grid item {...gridSizeMdLg1}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <TooltipIconEdit />
          </Grid>
        )
      }

      <CustomTextFieldNumberComponente
        required={false}
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        size={gridSizeMdLg6}
        type={TiposTextFieldNumberEnum.CELULAR}
        label={'Celular Responsable Contable'}
        error={errors.responsable_contable_celular}
        helperText={errors.responsable_contable_celular?.message}
        control={form.control}
        defaultValue={form.getValues().responsable_contable_celular || ''}
        name="responsable_contable_celular"
        customRestriccionCelular={valorRestriccionCel}
      />

      <CustomTextField
        endAdornmentInput={editSupervisor ? <TooltipIconEdit /> : null}
        size={gridSizeMdLg6}
        type="email"
        label={'Correo electronico para facturación'}
        error={errors.email_facturacion}
        helperText={errors.email_facturacion?.message}
        control={form.control}
        defaultValue={form.getValues().email_facturacion}
        name="email_facturacion"
      />

      <CustomTextField
        size={gridSizeMdLg12}
        label={'Dirección de Facturación'}
        error={errors.direccion_facturacion}
        helperText={errors.direccion_facturacion?.message}
        control={form.control}
        defaultValue={form.getValues().direccion_facturacion}
        name="direccion_facturacion"
      />

      



    </Grid>
  )

}